<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Update Grade</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Campaign:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ gradeDescription.campaign_name }}
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Grade:</span>
            </div>

            <div class="vx-col">
              <vs-input-number
                disabled
                class="w-full"
                name="grade"
                v-model="gradeDescription.grade"
                v-validate="'required'"
                data-vv-as="Grade"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('grade')"
              >{{ errors.first("grade") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="description"
                v-model="gradeDescription.description"
                v-validate="'required'"
                data-vv-as="Grades Description"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Grade Steps:</span>
            </div>

            <div
              class="m-5"
              v-for="(step, index) in all_grade_steps"
              :key="index"
            >
              <vs-checkbox
                class="mb-2"
                name="grade_step"
                v-model="gradeDescription.grade_steps"
                :vs-value="step"
                >{{ step.step_name }}</vs-checkbox
              >
            </div>
          </div>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="updateForm"
                >Submit</vs-button
              >
            </div>
          </div>
          <DataGrid :context="'Grades'" 
            ref="grades"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleGradeManagement from "@/store/grade-management/moduleGradeManagement.js";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
      all_grade_steps: [],
      user_role: null,
      companySearchComponentKey: 0,
      gradeDescription: [],
      grade_id: null,
      columnDefs: [
        {
          headerName: "Campaign",
          flex: 1,
          field: "campaign_name",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Grade",
          flex: 1,
          field: "grade",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Description",
          flex: 1,
          field: "description",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          flex: 1,

          headerName: "Grade Steps",
          field: "grade_steps",

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        }
      ],
      dataSource: {},
      records: [],
      selected: [],
      allGrades: [],
      abilities: null,
      gradeDescription: {
        grade: 0,
        description: null,
        grade_steps: 0,
        campaign: []
      }
    };
  },
  components: {
    "v-select": vSelect,
    moduleGradeManagement,
    DataGrid,
    CampaignAutocomplete
  },
  created() {
    var self = this;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_role = userInfo["userRole"];
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleGradeManagement.isRegistered) {
      this.$store.registerModule("GradesManagement", moduleGradeManagement);
      moduleGradeManagement.isRegistered = true;
    }

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  },
  mounted() {
    this.grade_id = this.$route.params.gradeId;
    this.fetchGrade();
  },
  watch: {},
  methods: {
    getAllGradeSteps() {
      let selected_campaign = {};
      selected_campaign.id = this.gradeDescription.campaign_id;
      let self = this;
      self.$store
        .dispatch("campaignsManagement/getAllGradeSteps", selected_campaign)
        .then(response => {
          self.all_grade_steps = response.data;

          let selected_grade_steps = [];
          self.all_grade_steps.forEach(function(ele) {
            console.log(ele.step_name);

            console.log(self.gradeDescription);

            if (
              self.gradeDescription.grade_steps.some(
                item => item === ele.step_name
              )
            ) {
              selected_grade_steps.push(ele);
            }
          });

          self.gradeDescription.grade_steps = selected_grade_steps;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    handleChildEvent() {
      let self = this;
      let result = moduleCampaignManagement.state.campaign.datas;
      self.selected_campaign = result[0];
      self.grades.campaign = self.selected_campaign;
      console.log(self.selected_campaign);
    },
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                } 
                // else {
                //   mappedArray.push({
                //     id: data[property].id,
                //     name: data[property].company_name + " (Client)",
                //     type: "client"
                //   });
                // }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch("GradesManagement/getAllGrades", params.request)
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.grades.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.grades.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    },
    updateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updateGrades();
        }
      });
    },
    updateGrades() {
      this.$store
        .dispatch("GradesManagement/updateGrades", this.gradeDescription)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Grades Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Grades Updated",
              text: "The grades was updated successfully"
            });
            this.$router.push({ path: "/grades" });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchGrade() {
      let self = this;

      this.$store
        .dispatch("GradesManagement/fetchGrades", self.grade_id)
        .then(res => {
          let result = JSON.parse(res.data);

          self.gradeDescription = result[0];
          this.getAllGradeSteps();
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
